import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import StatsSection from './components/StatsSection';
import ArticlesSection from './components/ArticlesSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

const siteUrl = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env.VITE_SITE_URL || 'https://allchinabuyspreadsheet.skin' : 'https://allchinabuyspreadsheet.skin';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'AllChinaBuy Spreadsheet',
  url: siteUrl,
  description: 'The ultimate AllChinaBuy Spreadsheet resource with trusted sellers, verified products, Yupoo links, product guides, shipping tips, and safe buying recommendations. Updated daily for 2026.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'AllChinaBuy Spreadsheet',
  url: siteUrl,
  logo: 'https://static.readdy.io/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg',
  description: 'The leading resource for the AllChinaBuy Spreadsheet — helping international buyers discover trusted sellers and shop safely.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(websiteSchema),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(organizationSchema),
        }}
      />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <StatsSection />
      <ArticlesSection />
      <TestimonialSection />
      <CTASection />
      <FAQSection />
      <Footer />
    </main>
  );
}